import React from "react";
import { Navigate } from "react-router-dom";
import Loading from "../Loading";
import { usePermissoes } from "../../config/Context/PermissoesContext";

/**
 * Protege rota por chaves de permissão (TXM-216).
 * Exibe loading apenas no carregamento inicial; refresh silencioso de permissões não deve desmontar a tela atual.
 */
export default function RotaProtegida({ anyOf = [], children }) {
  const { pode, carregado } = usePermissoes();

  if (!carregado) {
    return <Loading loading={true} color="white" />;
  }

  if (!pode(anyOf)) {
    return <Navigate to="/acesso-negado" replace />;
  }

  return children;
}
